// Test-mode prefills for the sign-up flow — only applied when the URL
// has `?test=1`. Lets you test the whole flow without filling the form
// every time. Visit `/sign-up/step-1?test=1` for a fully prefilled run.
//
// STRIPE 3DS TEST CARDS (use in step-2 payment form):
//   4000002760003184  → requires 3DS, succeeds after auth (RECOMMENDED)
//   4000000000003220  → standard 3DS2 inline challenge
//   4000002500003155  → 3DS2 with authentication
//   4000008260003178  → 3DS with redirect flow
//
// To force the full-page REDIRECT path (instead of inline modal), change
// `redirect: 'if_required'` → `redirect: 'always'` in the
// `stripe.confirmPayment({...})` call sites (StepTwoNew / StepFive).
// Otherwise Stripe uses an inline iframe modal for card 3DS.

export const isSignUpTestMode = () =>
  new URLSearchParams(window.location.search).get('test') === '1';

export const STEP_ONE_TEST_DEFAULTS = {
  email: 'test.3ds@example.com',
  confirmEmail: 'test.3ds@example.com',
  full_name: 'Test User',
  company: 'Test Co',
  mobile_phone: '(555) 555-5555',
  address: '123 Test Street',
  city: 'New York',
  state: 'NY', // any valid US state code from PaymentForm.REGION_CHOICES
  zip_code: '10001',
  industry: 'Real Estate',
  howDidYouHearAboutUs: 'Google Search',
  password: 'TestPass123!',
  password2: 'TestPass123!',
  first_security_question: '0',
  first_question_answer: 'Chicago',
  second_security_question: '0',
  second_question_answer: 'Smith',
};

export const STEP_TWO_TEST_DEFAULTS = {
  number: '4000002760003184', // Stripe 3DS test card
  holder: 'Test User',
  cvv: '123',
  street_address: '123 Test Street',
  locality: 'New York',
  postal_code: '10001',
};

// Apply defaults to an inputScheme in place, keyed by field name.
// Each matching field's `value` is overwritten.
export const applyTestDefaults = (inputScheme, defaults) => {
  if (!isSignUpTestMode()) return inputScheme;
  Object.keys(defaults).forEach((key) => {
    if (inputScheme[key]) {
      inputScheme[key].value = defaults[key];
    }
  });
  return inputScheme;
};
